import { withInstall } from '@map-sdk/utils'

import baseDrawStyleEditor from './src/index.vue'

export const BaseDrawStyleEditor = withInstall(baseDrawStyleEditor)
export default BaseDrawStyleEditor
